var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatcontactrecei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30.001,
    viewBox: "0 0 30 30.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_10",
    "data-name": "Subtraction 10",
    d: "M-10909-16352h-26a2,2,0,0,1-2-2v-4h2a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-2v-3h2a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-2v-3h2a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-2v-3h2a1,1,0,0,0,1-1,1,1,0,0,0-1-1h-2v-5a2,2,0,0,1,2-2h26a2,2,0,0,1,2,2v26A2,2,0,0,1-10909-16352Zm-15.666-13.648a.648.648,0,0,0-.118.011,5.376,5.376,0,0,0-3.745,2.327,4.8,4.8,0,0,0-.436.789.382.382,0,0,0,.021.354,8.22,8.22,0,0,0,.51.753,7.4,7.4,0,0,0,.876.979c.248.245.536.476.813.7l.031.024.03.024a8.622,8.622,0,0,0,5.168,1.689,8.644,8.644,0,0,0,5.168-1.689,9.138,9.138,0,0,0,.872-.748,9.522,9.522,0,0,0,.876-.979,7.446,7.446,0,0,0,.514-.753.311.311,0,0,0,.054-.354,3.737,3.737,0,0,0-.437-.789,5.442,5.442,0,0,0-3.741-2.327c-.035,0-.065,0-.095,0a.78.78,0,0,0-.456.137,4.631,4.631,0,0,1-2.738.884,4.618,4.618,0,0,1-2.733-.884A.746.746,0,0,0-10924.667-16365.648Zm3.167-9.351a4.3,4.3,0,0,0-4.3,4.3,4.3,4.3,0,0,0,4.3,4.3,4.3,4.3,0,0,0,4.3-4.3A4.305,4.305,0,0,0-10921.5-16375Z",
    transform: "translate(10936.999 16382.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatcontactrecei);
export default __webpack_public_path__ + "static/media/chatcontactrecei.6fec666f.svg";
export { ForwardRef as ReactComponent };